<a
  class="cons-nav--step"
  [routerLink]="loc.url"
  *ngFor="let loc of locations; index as $index"
  [ngClass]="{'current': isCurrent(loc)}"
>
  <div class="cons-nav--between" *ngIf="$index > 0"></div>
  <span class="cons-nav--link"> {{loc.name}} </span>
</a>
